import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { fetchTaxIdDuplication } from 'clickNgo/services/validation'

interface ICheckTaxIdDuplication {
  taxId: string
  hierarchyType: PartnerHierarchyType
}

export const checkTaxIdDuplication = ({ taxId, hierarchyType }: ICheckTaxIdDuplication) => {
  const shouldSkipChecking = [PartnerHierarchyType.BRANCH, PartnerHierarchyType.ONLINE].includes(
    hierarchyType
  )

  if (shouldSkipChecking) {
    return ''
  }

  // return fetchTaxIdDuplication({ taxId }).then((data) => (data.length ? 'Such Tax ID exists' : ''))
  return fetchTaxIdDuplication({ taxId }).then((data) => {
    if (!data?.length) {
      return ''
    }

    const duplicatedPartnersInfo = data
      .map(
        (partner) =>
          `<br />
        <span>
            <span>Name: <b>${partner.communicationName}</b></span><br />
            <span>Partner ID: <b>${partner.partnerId}</b></span><br />
            <span>Location ID: <b>${partner.locationId}</b></span><br />
            </span>`
      )
      .join('; ')

    return `<span>Such Tax ID exists. Duplicated partners info:</span> ${duplicatedPartnersInfo}`
  })
}
